import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ObjectTypes } from '@fi-shared/types';
import { FiCheckboxDisabledFn, IFiCheckboxItem } from '@fi-shared/fi-checkbox2/fi-checkbox2';
import { FiAccessRightFiltersManualSelectionBaseDirective } from '@fi-shared/access-right-filters/access-right-filters-manual-selection/fi-access-right-filters-manual-selection-base.directive';

@Component({
    selector: 'fi-access-rights-manual-selection-business-area',
    template: `
        <fi-checkbox2
            [item]="itemsListData"
            [(ngModel)]="ngModel"
            (ngModelChange)="onSelectionChange()"
            [canChangeChecked]="canChangeAccessRight.bind(this)"
            [isCheckboxDisabledFn]="isBusinessAreaDisabledFn.bind(this)"
        />
    `,
    styleUrls: ['./fi-access-rights-manual-selection-business-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-access-rights-manual-selection-business-area' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiAccessRightsManualSelectionBusinessAreaComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiAccessRightsManualSelectionBusinessAreaComponent,
        },
    ],
    standalone: false,
})
export class FiAccessRightsManualSelectionBusinessAreaComponent extends FiAccessRightFiltersManualSelectionBaseDirective {
    @Input() accessRightCoreBusinessAreaIds: number[] = [];
    ObjectType: ObjectTypes = ObjectTypes.BusinessArea;

    isBusinessAreaDisabledFn: FiCheckboxDisabledFn = (item: IFiCheckboxItem) => {
        return this.fiAccessRightHelperService.isBusinessAreaDisabled({
            initialSelectedBusinessAreaIds: this.initialSelectionItemIds,
            businessAreaIds: this.accessRightCoreBusinessAreaIds,
            businessAreaId: item.id,
            notAvailableBusinessAreas: this.itemsOutOfScope,
        });
    };

    doValidate(): ValidationErrors {
        return { 'business-areas-not-selected': this.required && !this.ngModel.length };
    }
}
